import React from "react";
import { UserType } from "../../utils/enum";
import CustomerProfile from "./CustomerProfile";
import ClientProfile from "./ClientProfile";
import Profile from "./Profile";

const ProfileTab = ({ user, refetchMe, canAccessProfile }) => {
  const role = user?.role?.role;

  if (role === UserType.CUSTOMER) {
    return <CustomerProfile user={user} refetchMe={refetchMe} />;
  }

  if (role === UserType.CLIENT) {
    return <ClientProfile user={user} refetchMe={refetchMe} />;
  }

  return <Profile user={user} refetchMe={refetchMe} canAccessProfile={canAccessProfile} />;
};

export default ProfileTab;
